
import { useEffect} from 'react'

/**
 * 全屏页面禁止弹性滚动
 *
 */
export default function usePageDisableScroll( ) {
  useEffect(()=>{
    const htmlEl = document.querySelector('html')
    const bodyEl = document.querySelector('body')

    htmlEl.className = 'hidden'
    bodyEl.className = 'hidden'
    return () => {
      htmlEl.className = ''
      bodyEl.className = ''
    }
  }, [])
}
